var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgActivated = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 8,
  height: 18,
  viewBox: "0 0 8 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7 9L1 5V13L7 9Z",
  fill: "#FADAAA"
})));
export { SvgActivated as ReactComponent };
export default __webpack_public_path__ + "assets/icons/activated.c809f2.svg";